import { gql } from "@apollo/client";

type LCStation = {
	station_id: number
	device_id: number
	port: number
	config_count: number
	configs: LCStationConfig[]
}

type LCStationConfig = {
	value_type_id: number
	value: number
	value_min: number
	value_max: number
}


export const LC_STATION = gql`
query GetLcStation($domain: String!, $lanControllerId: Int!) {
	controller {
		lcStation(domain: $domain, lanControllerId: $lanControllerId) {
			station_id
			device_id
			port
			config_count
			configs {
				value_type_id
				value
				value_min
				value_max
			}
		}
	}
}
`

export interface LCStationResponse {
	controller: {
		lcStation: LCStation[] | null
	}
}

export interface LCStationArgs {
	domain: string;
	lanControllerId: number;
}

